import {EDeviceOrientationEnum} from './device-orientation.enum';

export interface IDeviceOrientation extends Object {
  deviceAngles: IDeviceOrientationAngle;
  isDeviceOrientationLoading: boolean;
  isDeviceScreenRotationLocked: boolean;
  orientation: EDeviceOrientationEnum;
  screenAngle: number;
}

export interface IDeviceOrientationAngle extends Object {
  /** Rotation Around the Z Axis (Compass Direction)   */
  alpha: number;
  /** Rotation Around the X Axis (Front-to-Back Tilt)  */
  beta: number;
  /** Rotation Around the Y Axis (Left-to-right Tilt) */
  gamma: number;
}

export const DEFAULT_DEVICE_ORIENTATION_ANGLES: Readonly<IDeviceOrientationAngle> = {
  alpha: 0,
  beta: 0,
  gamma: 0,
};

export const DEFAULT_DEVICE_ORIENTATION: Readonly<IDeviceOrientation> = {
  deviceAngles: {...DEFAULT_DEVICE_ORIENTATION_ANGLES},
  isDeviceOrientationLoading: false,
  isDeviceScreenRotationLocked: true,
  orientation: EDeviceOrientationEnum.Unknown,
  screenAngle: 0,
};